import { Stack } from '@mui/material';
import { RowSkeletonProps } from '../Skeleton.types';
import { SkeletonText } from './SkeletonText';
import { SkeletonCircle } from './SkeletonCircle';

export const RowSkeleton = ({ avatar = false, actions = false, sx }: RowSkeletonProps) => {
    return (
        <Stack direction="row" spacing={2} alignItems="center" sx={sx}>
            {avatar && <SkeletonCircle size={28} />}
            <SkeletonText width={182} height={14} />
            <Stack flex={1} />
            {actions && <SkeletonText width={84} height={14} />}
        </Stack>
    );
};

export const ClientSkeleton = ({ sx }: { sx?: RowSkeletonProps['sx'] }) => {
    return <RowSkeleton avatar actions sx={sx} />;
};
